

<mat-card class="ddc-card-with-title"  *ngIf="_currentProjetAnnee" >
  <mat-card-title>
    <span ddcLabel labelKey="appli.projetAnnee.onglet.suiviSGDF.carte.avis"></span>
  </mat-card-title>
  <mat-card-content>
    <div ddcLabel labelKey="appli.projetAnnee.onglet.suiviSGDF.avis" class="ddc-appli-description"></div>
    <div class="row" *ngFor = "let avis of getAvisProjetAnneeToDisplay()" >
      <ng-container *ngIf="this._currentUser.isCOMMAR; else readOnlyAvis">
        <mat-form-field floatLabel="always" class="col-md-3 col-12">
          <mat-label ddcLabel labelKey="{{avis.labelKey}}"></mat-label>
          <mat-select [formControl]="this.getAvisProjetAnneeFormControl(avis, 'statut')">
            <ng-container *ngFor="let option of avis.listAvis; let i = index;" >
              <mat-option [value]="option.value">
                {{option.text}}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>

        <mat-form-field floatLabel="always" class="col-md-12 col-12">
          <mat-label ddcLabel labelKey="bdd.projetAnneeAvis.commentaire"></mat-label>
          <textarea
            type="text"
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="0"
            [formControl]="this.getAvisProjetAnneeFormControl(avis, 'commentaire')"
          >
          </textarea>
        </mat-form-field>
      </ng-container>
      <ng-template #readOnlyAvis>
        <div class="col-md-2 ddc-avis">
          <div class="ddc-read-only-data-container">
            <span class="ddc-label" ddcLabel labelKey="{{avis.labelKey}}"></span>
            <span class="ddc-value">{{this.getAvisProjetAnneeFormControl(avis, 'statut')?.value}}</span>
          </div>
        </div>
        <div class="col-md-10 ddc-avis">
          <div class="ddc-read-only-data-container">
            <span class="ddc-label" ddcLabel labelKey="bdd.projetAnneeAvis.commentaire"></span>:
            <span class="ddc-with-break-lines ddc-value">{{this.getAvisProjetAnneeFormControl(avis, 'commentaire')?.value}}</span>
          </div>
        </div>
      </ng-template>
    </div>
  </mat-card-content>
</mat-card>
